import type { ReactNode } from 'react'
import { Icon, type IconName } from './Icon'

/** A suggestion of what to do next on a page, with the buttons to do it. */
export function Suggestion({
  label,
  icon,
  title,
  children,
  actions,
}: {
  /** Names the landmark for assistive technology. */
  label: string
  icon: IconName
  title: ReactNode
  /** What follows the title. */
  children: ReactNode
  actions: ReactNode
}) {
  return (
    <aside className="suggestion-banner" aria-label={label}>
      <div className="suggestion-banner-icon" aria-hidden="true">
        <Icon name={icon} size={16} />
      </div>
      <div className="suggestion-banner-content">
        <strong>{title}</strong>
        {children}
      </div>
      <div className="suggestion-banner-actions">{actions}</div>
    </aside>
  )
}
